module.exports = __webpack_public_path__ + "img/3.da2f4005.jpg";